export default __webpack_public_path__ + "static/media/QUEROVET - LOGO BRANCO.676b0832.png";